/* fail-safe */try{
/* Proactive Coaching — school quote modal.
 *
 * Opens from anything carrying data-pc-quote (the two tier rows on /pricing/
 * and the invoice/PO button). data-tier on the trigger preselects the Plan,
 * so the row someone clicked is the row the form opens on.
 *
 * Submit POSTs to /quote on the pc-ask-bruce Worker, which mails
 * operations@proactivecoaching.ai direct via Resend. Any failure falls back to
 * a prefilled mailto: — the same contract the booking modal uses, because a
 * $1,500-$2,500 enquiry must never be lost to a failed fetch. TO below is the
 * PUBLISHED address (info@, a group that forwards to operations@) so the
 * fallback matches the address the modal shows the visitor.
 */
(function () {
    var modal = document.getElementById('pc-quote');
    var scrim = document.getElementById('pc-quote-scrim');
    var form = document.getElementById('pc-quote-form');
    if (!modal || !scrim || !form) return;

    var ENDPOINT = 'https://ask.proactivecoaching.ai/quote';
    var TO = 'info@proactivecoaching.ai';
    var done = document.getElementById('pc-quote-done');
    var sendBtn = form.querySelector('.pc-quote-send');
    var planSel = document.getElementById('pc-quote-plan');
    var extraEl = document.getElementById('pc-quote-extra');
    var estEl = document.getElementById('pc-quote-est');
    var lastFocus = null;

    /* Base prices live here AND on the card in page-pricing.hbs. If they ever
       diverge the card is the one people read, so change both together. */
    var BASE = { 0: 1500, 1: 2500 };
    var PER_EXTRA_SCHOOL = 500;

    function money(n) { return '$' + n.toLocaleString('en-US'); }

    function estimate() {
        if (!estEl) return;
        var base = BASE[planSel.selectedIndex];
        var extra = Math.max(0, parseInt(extraEl.value, 10) || 0);
        if (base === undefined) {            // "Not sure yet"
            estEl.textContent = extra
                ? 'Plus ' + money(extra * PER_EXTRA_SCHOOL) + ' for ' + extra +
                  ' additional school' + (extra === 1 ? '' : 's') + '.'
                : '';
            return;
        }
        var total = base + extra * PER_EXTRA_SCHOOL;
        estEl.textContent = extra
            ? 'Estimate: ' + money(base) + ' + ' + extra + ' \u00D7 ' + money(PER_EXTRA_SCHOOL) +
              ' = ' + money(total) + '/yr. We\u2019ll confirm in the quote.'
            : 'Estimate: ' + money(total) + '/yr. We\u2019ll confirm in the quote.';
    }
    if (planSel) planSel.addEventListener('change', estimate);
    if (extraEl) { extraEl.addEventListener('input', estimate); extraEl.addEventListener('change', estimate); }

    function open(tier) {
        if (tier && planSel) planSel.selectedIndex = (tier === 'unlimited') ? 1 : 0;
        estimate();
        /* Reopening after a send must show the form, not last time's receipt. */
        if (done) { done.hidden = true; form.hidden = false; }
        lastFocus = document.activeElement;
        modal.hidden = false; scrim.hidden = false;
        document.documentElement.classList.add('pc-book-open');
        var first = form.querySelector('input');
        if (first && window.matchMedia('(min-width: 768px)').matches) first.focus();
    }
    function close() {
        modal.hidden = true; scrim.hidden = true;
        document.documentElement.classList.remove('pc-book-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-pc-quote]');
        if (!t) return;
        e.preventDefault();
        open(t.getAttribute('data-tier'));
    });
    document.getElementById('pc-quote-close').addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
    });

    function fields() {
        var v = function (n) { return (form.elements[n] && form.elements[n].value || '').trim(); };
        return {
            name: v('name'), email: v('email'), phone: v('phone'), role: v('role'),
            org: v('org'), plan: v('plan'), coaches: v('coaches'),
            extra_schools: v('extra_schools'), po: v('po'), notes: v('notes'),
            website: v('website'),
            estimate: estEl ? estEl.textContent : ''
        };
    }

    function mailtoFallback(f) {
        var body = [
            'Name: ' + f.name,
            'Email: ' + f.email,
            'Phone: ' + (f.phone || '-'),
            'Role: ' + (f.role || '-'),
            'School / district: ' + f.org,
            'Plan: ' + f.plan,
            'Number of coaches: ' + (f.coaches || '-'),
            'Additional schools in district: ' + (f.extra_schools || '0'),
            'PO number: ' + (f.po || '-'),
            '',
            f.notes
        ].join('\n');
        location.href = 'mailto:' + TO +
            '?subject=' + encodeURIComponent('proactivecoaching.ai school membership request - ' + (f.org || f.name)) +
            '&body=' + encodeURIComponent(body);
        var note = form.querySelector('.pc-quote-note');
        if (note) note.innerHTML = 'Your email app should have opened with everything filled in - just hit send. ' +
            'If it didn\u2019t, email <b>' + TO + '</b>.';
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.reportValidity && !form.reportValidity()) return;
        var f = fields();
        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending\u2026';
        var restore = function () { sendBtn.disabled = false; sendBtn.innerHTML = 'Request a quote &rarr;'; };

        fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(f)
        }).then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            form.hidden = true;
            done.hidden = false;
            if (window.gtag) gtag('event', 'school_quote_request', { plan: f.plan, product: 'school_membership', page_type: 'page', post_path: location.pathname });
            // Meta needs its own signal: a quote never reaches Stripe, so the
            // Subscribe event can never fire for paid school traffic.
            // CompleteRegistration is what the school ad set optimises against --
            // Lead is the truer name for a quote request but Meta only offers it
            // under the Leads objective, and this campaign is Sales. Both fire so
            // a future Leads campaign has its event already flowing.
            // Plan only - never the name, email or phone from the form.
            if (window.fbq) {
                var qmeta = { content_name: 'school_membership_quote', content_category: f.plan };
                fbq('track', 'CompleteRegistration', qmeta);
                fbq('track', 'Lead', qmeta);
            }
        }).catch(function () {
            restore();
            mailtoFallback(f);
        });
    });

    var doneClose = done && done.querySelector('.pc-quote-done-close');
    if (doneClose) doneClose.addEventListener('click', close);
})();
}catch(e){/* never halt the bundle */}
